import { useEffect } from 'react';
import { useAppDispatch } from '../app/hooks';
import { useApiFeedback } from '../app/useApiFeedback';
import MessageResponse from '../common/feedback/messageResponse';
import AllApplicants from '../features/admin/components/Applications/AllApplicants';
import { fetchApplicationYearsThunk } from '../features/admin/thunks';

function Applications() {
  const dispatch = useAppDispatch();
  const { feedback, handleApiResponse } = useApiFeedback();

  useEffect(() => {
    void dispatch(fetchApplicationYearsThunk()).then((data) => {
      // Thunk result shape is compatible with MessageResponse in practice
      handleApiResponse(data as never, false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- load years once on mount
  }, [dispatch]);

  return (
    <>
      <MessageResponse feedback={feedback} />
      <AllApplicants />
    </>
  );
}

export default Applications;